/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AdjacentGalleriesDto } from '../../models/adjacent-galleries-dto';

export interface GalleryControllerFindAdjacentV1$Params {

/**
 * 갤러리 ID
 */
  id: string;
}

export function galleryControllerFindAdjacentV1(http: HttpClient, rootUrl: string, params: GalleryControllerFindAdjacentV1$Params, context?: HttpContext): Observable<StrictHttpResponse<AdjacentGalleriesDto>> {
  const rb = new RequestBuilder(rootUrl, galleryControllerFindAdjacentV1.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AdjacentGalleriesDto>;
    })
  );
}

galleryControllerFindAdjacentV1.PATH = '/api/v1/gallery/{id}/adjacent';
